import { Injectable, Injector } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;

    constructor(private injector: Injector) {
        // Defer Router access to avoid NG0200 circular DI with UtilsService.
        queueMicrotask(() => {
            this.injector.get(Router).events.subscribe(event => {
                if (event instanceof NavigationStart) {
                    if (this.keepAfterNavigationChange) {
                        this.keepAfterNavigationChange = false;
                    } else {
                        this.subject.next(null);
                    }
                }
            });
        });
    }

    success(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message, duration: 10000 });
        // this.subject.next({ type: 'success', text: message });
    }

    message(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'message', text: message, duration: 10000 });
    }

    error(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message, duration: 25000 });
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}